export type QueryParamValue = string | (string | null)[] | null | undefined

// query-string parses a repeated key (`?cardId=a&cardId=b`) to an array and a
// bare key (`?cardId=`) to `''`. Collapse either to a single non-empty string
// (last wins), or `undefined`.
export const getStringQueryParam = (
  value: QueryParamValue,
): string | undefined => {
  const single = Array.isArray(value) ? value[value.length - 1] : value
  const normalized = typeof single === 'string' ? single.trim() : undefined

  return normalized || undefined
}
